import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface NotesListContextType {
  /** Re-fetches the notes list using the current sort/tag state held in Index.tsx. */
  refetch: () => Promise<void>;
  /** ID of the note that is currently in the fade-out transition, or null. */
  fadingNoteId: string | null;
  setFadingNoteId: (id: string | null) => void;
}

const NotesListContext = createContext<NotesListContextType | undefined>(undefined);

interface NotesListProviderProps {
  children: ReactNode;
  refetch: () => Promise<void>;
}

export const NotesListProvider: React.FC<NotesListProviderProps> = ({ children, refetch }) => {
  const [fadingNoteId, setFadingNoteId] = useState<string | null>(null);

  const stableRefetch = useCallback(refetch, [refetch]);

  return (
    <NotesListContext.Provider value={{ refetch: stableRefetch, fadingNoteId, setFadingNoteId }}>
      {children}
    </NotesListContext.Provider>
  );
};

export function useNotesListContext(): NotesListContextType {
  const ctx = useContext(NotesListContext);
  if (!ctx) {
    throw new Error('useNotesListContext must be used within a NotesListProvider');
  }
  return ctx;
}

export default NotesListContext;

